export class ChartData {
    option: any = {};
    chartType = "";
    dataset = [];
    isEditingXAxis = false;
    isEditingYAxis = false;
    isDataset = false;
    working = false;
    workingTimer = 0;
    isEdEchartScatter07 = false; // 气泡图
    isEdEchartScatter01 = false; // 基础散点图
    isStackBarNor = false; // 堆叠柱状图的归一化
    isPieSum = false;
    isEDEchartbar13 = false; // 折柱图
    isEdEchartBarPolar = false; // 极坐标柱状标签
    loadOption(option, type) {
        this.option = JSON.parse(option);
        this.chartType = type;
        this.isEditingXAxis = false;
        this.isEditingYAxis = false;
        this.isDataset = false;
        this.isEdEchartScatter07 = this.option?.edEchartLabel === "scatter07";
        this.isEdEchartScatter01 = this.option?.edEchartLabel === "scatter01";
        this.isEDEchartbar13 = this.option?.edEchartLabel === "bar13";
        this.isEdEchartBarPolar = this.option?.series?.[0]?.coordinateSystem === "polar";
        this.isStackBarNor = ["bar19", "bar20"].includes(this.option?.edEchartLabel);
    }
    deepClone(obj: object) {
        return JSON.parse(JSON.stringify(obj));
    }
    /**
     * 将二维的数组进行“旋转”
     * @param arr 原始数组
     * @returns 新的数组
     */
    whirl2DArray(arr) {
        let maxLength = 0;
        let maxIndex = -1;

        arr.forEach((item, index) => {
            if (item.length > maxLength) {
                maxLength = item.length;
                maxIndex = index;
            }
        });

        if (maxIndex >= 0) {
            return arr[maxIndex].map((col, index) => arr.map((row) => row[index]));
        }

        return arr;
    }
    initDataSet() {
        let result: any = [];
        const nowOption = this.option;
        const seriesList = this.deepClone(nowOption.series);
        let isPercent = /%/.test(seriesList[0].label.formatter);
        const addPercent = (data) => {
            return isPercent ? `${data}%` : data;
        };
        if (nowOption.dataset) {
            this.isDataset = true;
            if (this.chartType == "bar") {
                result = this.deepClone(nowOption.dataset[0].source);
            } else if (this.chartType == "boxplot") {
                result = this.deepClone(nowOption.dataset[0].source);
                result = this.whirl2DArray(result);
                for (let i = 0; i < result.length; i++) {
                    for (let j = 0; j < result[i].length; j++) {
                        if (result[i][j] === undefined) {
                            result[i][j] = "";
                        }
                    }
                }
                result.unshift(nowOption.edEchartMap.map((item) => item.name));
            } else if (this.chartType == "candlestick") {
                result = this.deepClone(nowOption.dataset[0].source);
                result.unshift(["category", "Open Price", "Close Price", "Low Price", "High Price", "Total", "Type"]);
            }
            if (isPercent) {
                result = result.map((element, index) => {
                    if (index != 0) {
                        return element.map((data) => {
                            return (data += "%");
                        });
                    } else {
                        return element;
                    }
                });
            }
        } else {
            if (nowOption.edEchartLabel === "pie06") {
                // 嵌套环形图
                const seriesDataMap = new Map(nowOption.edEchartMap);
                for (let i = 0; i < seriesList[0].data.length; i++) {
                    if (!result[i]) {
                        result.push([]);
                    }
                    const item = seriesList[0].data[i];
                    result[i][0] = seriesDataMap.get(item.name);
                    result[i][1] = item.name;
                    result[i][2] = item.value;
                }
                result.unshift(["category", seriesList[0].name, "value"]);
            } else if (this.chartType == "pie") {
                this.isPieSum = false;
                let data = seriesList[0].data;
                for (let i = 0; i < data.length; i++) {
                    if (data[i]?.itemStyle?.color == "none") {
                        this.isPieSum = true;
                        continue;
                    }
                    if (!result[i]) {
                        result.push([]);
                    }
                    result[i][0] = data[i].name;
                    result[i][1] = addPercent(data[i].value);
                }
            } else if (this.chartType == "scatter") {
                if (this.isEdEchartScatter01) {
                    result.push(["x", "y"]);
                    seriesList[0].data.forEach((item) => {
                        result.push(item.value);
                    });
                } else if (this.isEdEchartScatter07) {
                    for (let i = 0; i < seriesList.length; i++) {
                        let series = seriesList[i];
                        let name = [series.name];
                        if (!result[0]) {
                            result.push(name);
                        } else {
                            result[0] = result[0].concat(name);
                        }
                        for (let j = 0; j < series.data.length; j++) {
                            let numData = [`(${series.data[j][0]}, ${series.data[j][1]}, ${series.data[j][2]})`];
                            if (!result[j + 1]) {
                                result.push(numData);
                            } else {
                                result[j + 1] = result[j + 1].concat(numData);
                            }
                        }
                    }
                } else {
                    let seriesName = seriesList.map((item) => item.name);
                    result.push(["x"].concat(seriesName));
                    let map = new Map();
                    for (let i = 0; i < seriesList.length; i++) {
                        let series = seriesList[i];
                        for (let j = 0; j < series.data.length; j++) {
                            let nowData = series.data[j];
                            let yIndex = map.get(nowData[0]);
                            if (yIndex) {
                                result[yIndex][i + 1] = nowData[1];
                            } else {
                                result.push([nowData[0]]);
                                let yIndex = result.length - 1;
                                result[yIndex][i + 1] = nowData[1];
                                map.set(nowData[0], yIndex);
                            }
                        }
                    }
                }
            } else if (this.chartType == "candlestick") {
                for (let i = 0; i < seriesList.length; i++) {
                    let series = seriesList[i];
                    let name = ["Open Price", "Close Price", "Low Price", "High Price"];
                    if (!result[0]) {
                        result.push(name);
                    } else {
                        result[0] = result[0].concat(name);
                    }
                    for (let j = 0; j < series.data.length; j++) {
                        let numData = [series.data[j][0], series.data[j][1], series.data[j][2], series.data[j][3]];
                        if (!result[j + 1]) {
                            result.push(numData);
                        } else {
                            result[j + 1] = result[j + 1].concat(numData);
                        }
                    }
                }
            } else if (this.chartType == "radar") {
                let radar = nowOption.radar;
                for (let i = 0; i < radar.length; i++) {
                    let dataArr = radar[i].indicator;
                    let dataLength = seriesList[i].data.length;
                    let seriesValueName = [];
                    for (let k = 0; k < dataLength; k++) {
                        seriesValueName.push(seriesList[i].data[k].name);
                    }
                    let name = [seriesList[i].name, "max", "min"].concat(seriesValueName);
                    let dataIndex = 0;
                    if (!result[0]) {
                        result.push(name);
                    } else {
                        dataIndex = result[0].length;
                        result[0] = result[0].concat(name);
                    }
                    for (let j = 0; j < dataArr.length; j++) {
                        let values = seriesList[i].data.map((item: any) => item.value[j]);
                        let numData = [dataArr[j].name || dataArr[j].text, dataArr[j].max, dataArr[j].min].concat(values);
                        if (!result[j + 1]) {
                            result.push(new Array(dataIndex).fill(""));
                            result[j + 1] = result[j + 1].concat(numData);
                        } else {
                            result[j + 1] = result[j + 1].concat(numData);
                        }
                    }
                }
            } else if (this.chartType == "heatmap") {
                result = this.deepClone(seriesList[0].data);
                for (let i = 1; i < seriesList.length; i++) {
                    let source = seriesList[i].data;
                    for (let j = 0; j < source.length; j++) {
                        if (result[j]) {
                            result[j] = result[j].concat(source[j]);
                        } else {
                            let temp = new Array(result[j - 1].length).fill("");
                            result.push(temp.concat(source[j]));
                        }
                    }
                }
            } else if (this.chartType == "graph") {
                const categoriesMap = (categories) => {
                    let map = new Map();
                    categories.forEach((item, index) => {
                        map.set(index, item.name);
                    });
                    return map;
                };
                const dataMap = (data, cMap) => {
                    let map = new Map();
                    data.forEach((item) => {
                        map.set(item.id, {
                            ...item,
                            category: cMap.get(item.category),
                        });
                    });
                    return map;
                };
                result.push(["categories", "source", "value", "target"]);
                seriesList.forEach((series) => {
                    const cMap = categoriesMap(series.categories);
                    const dMap = dataMap(series.data, cMap);
                    let dataList = series.data.map((item) => item.id);
                    series.links.forEach((link) => {
                        let source = dMap.get(link.source);
                        let target = dMap.get(link.target);
                        result.push([source.category, source.name, source.value, target.name]);
                        let index = dataList.findIndex((item) => item == link.source);
                        if (index != -1) {
                            dataList.splice(index, 1);
                        }
                    });
                    for (let i of dataList) {
                        let data = dMap.get(i);
                        result.push([data.category, data.name, data.value]);
                    }
                });
            } else if (this.chartType == "sunburst") {
                const flat = (data: any, parentName = "null") => {
                    return data.reduce((acc: any, curr: any) => {
                        acc.push({ ...curr, parentName, value: curr.value });
                        if (curr.children) {
                            acc = acc.concat(flat(curr.children, curr.name));
                        }
                        return acc;
                    }, []);
                };
                let flatTree = flat(seriesList[0].data);
                result.push(["name", "value", "parent"]);
                for (let i = 0; i < flatTree.length; i++) {
                    let item = flatTree[i];
                    result.push([item.name, item.value, item.parentName]);
                }
            } else if (this.chartType == "parallel") {
                let parallelAxis = nowOption.parallelAxis.map((item) => item.name);
                let temp = [];
                seriesList.forEach((series) => {
                    if (!temp[0]) {
                        temp.push(["", series.name]);
                    } else {
                        temp[0].push(series.name);
                    }
                    let index = 0;
                    while (index < series.data.length - 1) {
                        temp[0].push("");
                        index++;
                    }

                    if (!temp[1]) {
                        temp.push([""]);
                    }
                    for (let i = 0; i < parallelAxis.length; i++) {
                        if (!temp[2 + i]) {
                            temp.push([parallelAxis[i]]);
                        }
                    }
                    series.data.forEach((dataList, dataIndex) => {
                        dataList.forEach((element, index) => {
                            if (index == 0) {
                                temp[1].push(`data${dataIndex + 1}`);
                            }
                            temp[2 + index].push(element);
                        });
                    });
                });
                result = temp;
            } else if (this.chartType == "sankey") {
                let links = seriesList[0].links;
                for (let item of links) {
                    let temp = [];
                    temp.push(item.source);
                    temp.push(item.target);
                    temp.push(item.value);
                    result.push(temp);
                }
            } else if (this.chartType == "funnel") {
                for (let i = 0; i < seriesList.length; i++) {
                    let data = seriesList[i].data;
                    for (let j = 0; j < data.length; j++) {
                        let temp = [];
                        temp.push(data[j].name);
                        temp.push(data[j].value);
                        result.push(temp);
                    }
                }
            } else if (this.chartType == "gauge") {
                for (let i = 0; i < seriesList.length; i++) {
                    let data = seriesList[i].data;
                    if (data) {
                        for (let j = 0; j < data.length; j++) {
                            let temp = [];
                            temp.push(data[j].name);
                            temp.push(data[j].value);
                            result.push(temp);
                        }
                    }
                }
            } else if (this.chartType == "waterfall") {
                result = Array.from(Array(seriesList[0].data.length)).map((item) => [0]);
                seriesList[1].data.forEach((item, index) => {
                    const val = Number(item.value ?? item);
                    if (val >= 0) {
                        result[index] = [val];
                    }
                });
                seriesList[2].data.forEach((item, index) => {
                    const val = Number(item.value ?? item);
                    if (val >= 0) {
                        result[index] = [-val];
                    }
                });
                result.unshift(["Date", "Value"]);
            } else {
                const nameList = [];
                for (let i = 0; i < seriesList.length; i++) {
                    let name = seriesList[i].name;
                    let data = seriesList[i].data;
                    if (this.isStackBarNor) {
                        data = seriesList[i].edOriginData;
                    }
                    nameList.push(name);
                    if (data.length > 0) {
                        for (let j = 0; j < data.length; j++) {
                            if (!result[j]) {
                                result.push([]);
                            }
                            result[j][i] = addPercent(data[j]);
                        }
                    }
                }
                result.unshift(nameList);
            }
        }
        this.initYAxisData(result, nowOption.dataset);
        this.initXAxisData(result, nowOption.dataset);
        this.dataset = result;
        this.working = true;
        clearTimeout(this.workingTimer);
        return this.dataset;
    }
    initXAxisData(arr: string[][], isDataset = false) {
        if (!!isDataset) {
            return arr;
        }

        if (["line", "bar", "candlestick", "linebar"].includes(this.chartType)) {
            let data = this.getXAxis();
            if (!data) return arr;
            if (data.length >= arr.length) {
                arr = arr.concat(Array(data.length - arr.length).fill([]));
            } else {
                data = data.concat(Array(arr.length - data.length).fill(""));
            }
            for (let i = 0; i < data.length; i++) {
                arr[i].unshift(data[i]);
            }
        }

        if (this.chartType === "waterfall") {
            let data = this.getXAxis();
            if (!data) return arr;
            data.forEach((item, index) => {
                if (index > 0) {
                    arr[index].unshift(item);
                }
            });
        }

        return arr;
    }
    initYAxisData(arr: string[][], isDataset = false) {
        if (!isDataset && ["line", "bar", "candlestick", "linebar"].includes(this.chartType)) {
            let data = this.getYAxis();
            if (!data) return arr;
            if (data.length >= arr.length) {
                arr = arr.concat(Array(data.length - arr.length).fill([]));
            } else {
                data = data.concat(Array(arr.length - data.length).fill(""));
            }
            for (let i = 0; i < data.length; i++) {
                arr[i].unshift(data[i]);
            }
        } else {
            return arr;
        }
    }
    getXAxis() {
        const nowOption = this.option;

        if (this.isEdEchartBarPolar) {
            if (!nowOption.radiusAxis || !nowOption.radiusAxis[0] || !nowOption.radiusAxis[0].data) return;
            const data = this.deepClone(nowOption.radiusAxis[0].data);
            data.unshift("category");
            this.isEditingXAxis = true;
            return data;
        }

        if (!nowOption.xAxis || !nowOption.xAxis[0] || !nowOption.xAxis[0].data) return;
        const data = this.deepClone(nowOption.xAxis[0].data);
        data.unshift("category");
        this.isEditingXAxis = true;
        return data;
    }
    setXAxis(data: Array<string>) {
        data.shift();
        data = data.filter((item) => item != "");
        const nowOption = this.option;

        if (this.isEdEchartBarPolar) {
            const temp = this.deepClone(nowOption.radiusAxis);
            temp[0].data = data;
            return { radiusAxis: temp };
        }

        const temp = this.deepClone(nowOption.xAxis);
        temp[0].data = data;
        return { xAxis: temp };
    }
    getYAxis() {
        const nowOption = this.option;
        if (!nowOption.yAxis || !nowOption.yAxis[0] || !nowOption.yAxis[0].data) return;
        const data = this.deepClone(nowOption.yAxis[0].data);
        data.unshift("category");
        this.isEditingYAxis = true;
        return data;
    }
    setYAxis(data: Array<string>) {
        data.shift();
        data = data.filter((item) => item != "");
        const nowOption = this.option;
        const temp = this.deepClone(nowOption.yAxis);
        temp[0].data = data;
        return { yAxis: temp };
    }
    datasetLegend(legend: any, type: string, index: number, nv: string, ov?: string) {
        const changeLegend = (nv: string, ov: string) => {
            if (nv == ov) return;
            if (index != -1) {
                legend[0].data.splice(index, 1, nv);
            }
            let keys = Object.keys(legend[0].selected);
            if (keys.includes(ov)) {
                let obj = {
                    [nv]: legend[0].selected[ov],
                };
                delete legend[0].selected[ov];
                Object.assign(legend[0].selected, obj);
            }
        };
        const addLegend = (nv: string) => {
            legend[0].data.push(nv);
        };
        const deleteLegend = (v: string) => {
            let index = legend[0].data.indexOf(v);
            legend[0].data.splice(index, 1);
            let keys = Object.keys(legend[0].selected);
            if (keys.includes(v)) {
                delete legend[0].selected[v];
            }
        };
        switch (type) {
            case "change": {
                changeLegend(nv, ov as string);
                break;
            }
            case "add": {
                addLegend(nv);
                break;
            }
            case "delete": {
                // 此处nv是旧名称
                deleteLegend(nv);
            }
        }
    }
    getDefaultData(type: string) {
        const nowOption = this.option;
        const seriesList = nowOption.series;
        let tempObj: any = {};
        if (seriesList[0]) {
            tempObj = seriesList[0];
            delete tempObj.name;
            delete tempObj.type;
            delete tempObj.data;
        }
        switch (type) {
            case "line_series": {
                return Object.assign(
                    {
                        type: "line",
                        data: [],
                    },
                    tempObj
                );
            }
            case "bar_series": {
                return Object.assign(
                    {
                        data: [],
                        type: "bar",
                    },
                    tempObj
                );
            }
            case "linebar_series": {
                return Object.assign(
                    {
                        data: [],
                        type: "line",
                    },
                    tempObj
                );
            }
            case "radar": {
                return {
                    indicator: [],
                    radius: 80,
                };
            }
            case "radar_series": {
                return {
                    name: "",
                    type: "radar",
                    data: [],
                };
            }
        }
    }
    setSeriesColor(seriesList: any) {
        const defaultColorList = this.option.color || [
            "#5470c6",
            "#91cc75",
            "#fac858",
            "#ee6666",
            "#73c0de",
            "#3ba272",
            "#fc8452",
            "#9a60b4",
            "#ea7ccc",
        ];

        if (this.chartType == "radar") {
            seriesList.forEach((series, index) => {
                series.data.forEach((item) => {
                    let color = defaultColorList[index % defaultColorList.length];
                    if (item?.itemStyle?.color) {
                    } else {
                        Object.assign(item, {
                            itemStyle: {
                                color: color,
                            },
                        });
                    }
                });
            });
        } else {
            seriesList.forEach((item, index) => {
                let color = defaultColorList[index % defaultColorList.length];
                if (item?.itemStyle?.color) {
                } else {
                    Object.assign(item, {
                        itemStyle: {
                            color: color,
                        },
                    });
                }
            });
        }
    }
    getSeriesColor(index: number) {
        const defaultColorList = this.option.color || [
            "#5470c6",
            "#91cc75",
            "#fac858",
            "#ee6666",
            "#73c0de",
            "#3ba272",
            "#fc8452",
            "#9a60b4",
            "#ea7ccc",
        ];
        return defaultColorList[index % defaultColorList.length];
    }
    dataAdapter(obj) {
        if (["sunburst", "sanky", "funnel", "graph", "parallel"].includes(this.chartType)) return obj;
        let keys = Object.keys(obj);
        if (keys.includes("series")) {
            this.setSeriesColor(obj.series);
        }
        return obj;
    }

    addPercentLabel(series) {
        series.forEach((item) => {
            if (item?.label) {
                let oldStr = item.label.formatter;
                if (!/%/.test(oldStr)) {
                    if (/\{c\}/.test(oldStr)) {
                        item.label.formatter = oldStr.replace(/\{c\}/, "{c}%");
                    } else {
                        item.label.formatter = "{c}%";
                    }
                }
            }
        });
    }
    removePercentLabel(series) {
        series.forEach((item) => {
            if (item?.label?.formatter) {
                item.label.formatter = item.label.formatter.replace(/%/, "");
            }
        });
    }
    changePercentArr(arr) {
        let list = [];
        let isPercent = false;
        for (let i = 0; i < arr.length; i++) {
            let line = [];
            for (let j = 0; j < arr[i].length; j++) {
                let str = arr[i][j];
                if (/%/.test(str)) {
                    isPercent = true;
                    line.push(str.replace(/[^\d|.]/, ""));
                } else {
                    line.push(str);
                }
            }
            list.push(line);
        }
        return { list, isPercent };
    }

    autoRelease() {
        clearTimeout(this.workingTimer);
        this.workingTimer = setTimeout(() => {
            this.working = true;
        }, 1500);
    }
    changeDataset(arr: Array<Array<string>>) {
        if (!this.working) return;
        this.working = false;
        this.autoRelease();
        const { list, isPercent } = this.changePercentArr(arr);
        arr = list;
        let result = null;
        let xChange = null,
            yChange = null;
        if (this.isEditingXAxis) {
            let xAxisData = arr.reduce((p, c) => {
                return p.push(c.shift()!), p;
            }, []);
            xChange = this.setXAxis(xAxisData);
        }
        if (this.isEditingYAxis) {
            let yAxisData = arr.reduce((p, c) => {
                return p.push(c.shift()!), p;
            }, []);
            yChange = this.setYAxis(yAxisData);
        }
        if (this.chartType == "pie") {
            result = this.changeDatasetForPie(arr);
        } else if (this.chartType == "scatter") {
            result = this.changeDatasetForScatter(arr);
        } else if (this.chartType == "candlestick") {
            if (this.isDataset) {
                arr.shift();
                const nowOption = this.option;
                const dataset = this.deepClone(nowOption.dataset);
                dataset[0].source = arr;
                result = {
                    dataset: dataset,
                };
            } else {
                result = this.changeDatasetForCandlestick(arr);
            }
        } else if (this.chartType == "radar") {
            result = this.changeDatasetForRadar(arr);
        } else if (this.chartType == "boxplot") {
            result = this.changeDatasetForBoxplot(arr);
        } else if (this.chartType == "heatmap") {
            result = this.changeDatasetForHeatmap(arr);
        } else if (this.chartType == "graph") {
            result = this.changeDatasetForGraph(arr);
        } else if (this.chartType == "sunburst") {
            result = this.changeDatasetForSunburst(arr);
        } else if (this.chartType == "parallel") {
            result = this.changeDatasetForParallel(arr);
        } else if (this.chartType == "sankey") {
            result = this.changeDatasetForSankey(arr);
        } else if (this.chartType == "funnel") {
            result = this.changeDatasetForFunnel(arr);
        } else if (this.chartType == "gauge") {
            result = this.changeDatasetForGauge(arr);
        } else if (this.chartType == "waterfall") {
            result = this.changeDatasetForWaterfall(arr);
        } else {
            if (this.isDataset) {
                const nowOption = this.option;
                const dataset = this.deepClone(nowOption.dataset);
                dataset[0].source = arr;
                result = {
                    dataset: dataset,
                };
            }
            const nowOption = this.option;
            let seriesList = this.deepClone(nowOption.series);
            const legend = this.deepClone(nowOption.legend);
            const changeDataSet = (arr: Array<Array<number | string>>) => {
                let result = [];
                for (let j = 0; j < arr[0].length; j++) {
                    let temp = [];
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[0][j] == "") {
                            break;
                        }
                        arr[i][j] != undefined && temp.push(arr[i][j]);
                    }
                    temp.length > 0 && result.push(temp);
                }
                return result;
            };
            let temp = changeDataSet(arr);
            let count = temp.length - seriesList.length;
            if (count == 0) {
                for (let i = 0; i < seriesList.length; i++) {
                    let name = temp[i].shift() as string;
                    let oldName = seriesList[i].name;
                    this.datasetLegend(legend, "change", i, name, oldName);
                    seriesList[i].name = name;
                    if (this.isStackBarNor) {
                        seriesList[i].edOriginData = temp[i];
                    } else {
                        seriesList[i].data = temp[i];
                    }
                }
            } else if (count > 0) {
                // 新增series
                let newSeries = [];
                legend[0].data = [];
                for (let i = 0; i < temp.length; i++) {
                    let tempSeries: any = this.getDefaultData(`${this.chartType}_series`);
                    let name = temp[i].shift() as string;
                    let oldData = seriesList.find((item) => item.name == name);
                    if (oldData) {
                        if (oldData.itemStyle) {
                            tempSeries.itemStyle = oldData.itemStyle;
                        } else {
                            tempSeries.itemStyle = {
                                color: this.getSeriesColor(i),
                            };
                        }
                        if (oldData.type) {
                            tempSeries.type = oldData.type;
                        }
                        if (oldData.yAxisIndex) {
                            tempSeries.yAxisIndex = oldData.yAxisIndex;
                        }
                    }
                    if (this.isEDEchartbar13 && tempSeries.type == "line") {
                        tempSeries.yAxisIndex = 1;
                    }
                    tempSeries.name = name;
                    if (this.isStackBarNor) {
                        tempSeries.edOriginData = temp[i];
                    } else {
                        tempSeries.data = temp[i];
                    }
                    newSeries.push(tempSeries);
                    this.datasetLegend(legend, "add", i, name);
                }
                seriesList = newSeries;
            } else {
                // 删除series
                let nowNameList = arr[0];
                for (let i = arr[0].length; i >= 0; i--) {
                    if (seriesList[i] && arr[0][i] == "") {
                        this.datasetLegend(legend, "delete", i, seriesList[i].name);
                        seriesList.splice(i, 1);
                    }
                }
            }
            result = {
                series: seriesList,
                legend: legend,
            };
        }
        Object.assign(result, {
            ...xChange,
            ...yChange,
        });
        if (this.isStackBarNor) {
            this.formatOptionStackBarNor(result);
        }
        let keys = Object.keys(result);
        if (keys.includes("series")) {
            if (isPercent) {
                this.addPercentLabel(result.series);
            } else {
                this.removePercentLabel(result.series);
            }
        }
        return this.dataAdapter(result);
    }
    changeDatasetForPie06(arr: Array<Array<string>>) {
        const nowOption = this.option;
        const seriesList = this.deepClone(nowOption.series);
        const legend = this.deepClone(nowOption.legend);
        const edEchartMap = [];

        const outData = [];
        const inData = [];

        arr.forEach((item, index) => {
            if (index === 0) {
                seriesList[0].name = item[1];
                seriesList[1].name = item[1];
            } else {
                let value = Number(item[2]);
                value = isNaN(value) ? 0 : value;
                outData.push({
                    name: item[1],
                    value,
                });
                const inDataIndex = inData.findIndex((inItem) => inItem.name === item[0]);
                if (inDataIndex === -1) {
                    inData.push({
                        name: item[0],
                        value,
                    });
                } else {
                    inData[inDataIndex].value += value;
                }
                edEchartMap.push([item[1], item[0]]);
            }
        });

        // 填充itemStyle.color
        for (let i = 0; i < outData.length; i++) {
            outData[i].itemStyle = {
                color: seriesList[0]?.data?.[i]?.itemStyle?.color ?? nowOption.color[i % nowOption.color.length],
            };
        }
        for (let i = 0; i < inData.length; i++) {
            inData[i].itemStyle = {
                color: seriesList[1]?.data?.[i]?.itemStyle?.color ?? nowOption.color[i % nowOption.color.length],
            };
        }

        seriesList[0].data = outData;
        seriesList[1].data = inData;

        legend[0].data = outData.map((item) => item.name).concat(inData.map((item) => item.name));

        return {
            series: seriesList,
            legend: legend,
            edEchartMap,
        };
    }
    changeDatasetForPie(arr: Array<Array<string>>) {
        const nowOption = this.option;
        if (nowOption.edEchartLabel === "pie06") {
            return this.changeDatasetForPie06(arr);
        }

        const seriesList = this.deepClone(nowOption.series);
        const legend = this.deepClone(nowOption.legend);
        const oldData = seriesList[0].data;
        let sumSeries = null;
        if (this.isPieSum) {
            sumSeries = oldData.pop();
        }

        let tempData: Array<{ name: string; value: string; itemStyle: { color: string } }> = [];
        let count = arr.length - oldData.length;
        if (count == 0) {
            let deleteFlag = false;
            for (let i = 0; i < arr.length; i++) {
                let name = arr[i][0] as string;
                let oName = oldData[i].name;
                let oStyle = oldData[i].itemStyle;
                let value = arr[i][1] as string;
                if (arr[i].length != 1) {
                    this.datasetLegend(legend, "change", i, name, oName);
                    tempData.push({
                        value: value,
                        name: name,
                        itemStyle: oStyle,
                    });
                } else {
                    deleteFlag = true;
                    break;
                }
            }
            if (deleteFlag) {
                // 若有删除饼名称，则清除对应数据
                let nowNameList = arr.map((item: any) => item[0] || "");
                let legendNameList = legend[0].data;
                let deleteList = legendNameList.filter((item: string) => {
                    return !nowNameList.includes(item);
                });
                tempData = this.deepClone(oldData);
                for (let i = tempData.length - 1; i >= 0; i--) {
                    if (deleteList.includes(tempData[i].name)) {
                        this.datasetLegend(legend, "delete", i, tempData[i].name);
                        tempData.splice(i, 1);
                    }
                }
            }
        } else if (count > 0) {
            legend[0].data = [];
            for (let i = 0; i < arr.length; i++) {
                let name = (arr[i][0] as string) || "default";
                tempData.push({
                    value: arr[i][1] as string,
                    name: name,
                    itemStyle: oldData[i] ? oldData[i].itemStyle : { color: this.getSeriesColor(i) },
                });
                this.datasetLegend(legend, "add", i, name);
            }
        } else {
            // 删除series
            let nowNameList = arr.map((item: any) => item[0]);
            let legendNameList = legend[0].data;
            let deleteList = legendNameList.filter((item: string) => {
                return !nowNameList.includes(item);
            });
            console.log(legendNameList, deleteList);
            tempData = this.deepClone(oldData);
            for (let i = tempData.length - 1; i >= 0; i--) {
                if (deleteList.includes(tempData[i].name)) {
                    this.datasetLegend(legend, "delete", i, tempData[i].name);
                    tempData.splice(i, 1);
                }
            }
        }
        console.log(tempData);
        if (this.isPieSum) {
            let sum = 0;
            tempData.forEach((item) => {
                let num = parseFloat(item.value);
                if (!isNaN(num)) {
                    sum += num;
                }
            });
            sumSeries.value = sum;
            tempData.push(sumSeries);
        }
        Object.assign(seriesList[0], {
            data: tempData,
        });
        return {
            series: seriesList,
            legend: legend,
        };
    }
    changeDatasetForScatter(arr: Array<Array<string>>) {
        const nowOption = this.option;
        const seriesList = this.deepClone(nowOption.series);
        const legend = this.deepClone(nowOption.legend);
        let tempSeriesList = [];
        let legendNameList = [];
        let tempSeries = [];
        if (this.isEdEchartScatter07) {
            let nameList = arr.shift() as Array<string>;
            nameList = nameList.filter((item) => item != "");
            for (let i = 0; i < nameList.length; i++) {
                let name = nameList[i];
                let obj: any = {
                    name,
                    data: [],
                };
                for (let j = 0; j < arr.length; j++) {
                    let data = arr[j][i];
                    let list = data.split(/,|，/).map((item) => item.replace(/[^\d|.]/, ""));
                    obj.data.push([parseFloat(list[0]), parseFloat(list[1]), parseFloat(list[2])]);
                }
                tempSeries.push(obj);
            }
        } else if (this.isEdEchartScatter01) {
            const obj: any = {
                name: seriesList[0].name,
                data: [],
            };
            for (let i = 0; i < arr.length; i++) {
                if (i === 0) {
                    continue;
                }
                const scatterDataItem: any = {
                    value: [parseFloat(arr[i][0] || "0"), parseFloat(arr[i][1]) || "0"],
                };
                if (nowOption.series[0]?.data?.[i - 1]?.itemStyle) {
                    scatterDataItem.itemStyle = nowOption.series[0].data[i - 1].itemStyle;
                }
                obj.data.push(scatterDataItem);
            }
            tempSeries.push(obj);
        } else {
            let nameList = arr.shift() as Array<string>;
            nameList.shift();
            nameList = nameList.filter((item) => item != "");
            for (let i = 0; i < nameList.length; i++) {
                let name = nameList[i];
                let obj: any = {
                    name,
                    data: [],
                };
                for (let j = 0; j < arr.length; j++) {
                    let x = arr[j][0] || "0",
                        y = arr[j][1 + i] || "0";
                    obj.data.push([parseFloat(x), parseFloat(y)]);
                }
                tempSeries.push(obj);
            }
        }
        legend[0].data = [];
        for (let i = 0; i < tempSeries.length; i++) {
            legendNameList.push(tempSeries[i].name);

            let temp = this.deepClone(seriesList[0]);
            let name = tempSeries[i].name;
            temp.name = name;
            temp.data = tempSeries[i].data;
            let oldData = seriesList.find((item) => item.name == name);
            if (oldData && oldData.itemStyle) {
                temp["itemStyle"] = oldData.itemStyle;
            } else {
                temp["itemStyle"] = {
                    color: this.getSeriesColor(i),
                };
            }
            tempSeriesList.push(temp);
        }
        legend[0].data = legendNameList;
        return {
            series: tempSeriesList,
            legend: legend,
        };
    }
    changeDatasetForCandlestick(arr: Array<Array<string>>) {
        arr = arr.map((item) => item.slice(0, 4));
        const nowOption = this.option;
        const seriesList = this.deepClone(nowOption.series);
        const legend = this.deepClone(nowOption.legend);
        let nameList = arr.shift() as Array<string>;
        const temp: any = {
            name: "",
            type: "candlestick",
            data: [],
        };
        if (nameList.length == 4) {
            if (seriesList[0]) {
                seriesList[0].data = arr;
            } else {
                temp.data = arr;
                seriesList.push(temp);
            }
        } else {
            // 删除series
            this.datasetLegend(legend, "delete", 0, seriesList[0].name);
            seriesList.splice(0, 1);
        }
        return {
            series: seriesList,
            legend: legend,
        };
    }
    changeDatasetForRadar(arr: Array<Array<string>>) {
        const nowOption = this.option;
        const seriesList = this.deepClone(nowOption.series);
        const radar = this.deepClone(nowOption.radar);
        const legend = this.deepClone(nowOption.legend);
        let valueLength = seriesList[0].data.length; // 雷达图实际数据长度
        let nameList = arr.shift() as Array<string>;
        let inputValueLength = nameList.length - 3; // 编辑数据长度，可能新增或减少series
        const getItemStyle = (seriesName: string, index: number) => {
            let data = seriesList[0].data;
            let item = data.find((item) => item.name == seriesName);
            return item?.itemStyle || { color: this.getSeriesColor(index) };
        };
        let tempIndicatorData = [];
        for (let i = 0; i < nameList.length; ) {
            let lengthOffset = valueLength + 3;
            let indicatorData = [];
            for (let j = 0; j < arr.length; j++) {
                if (arr[j][i]) {
                    indicatorData.push({
                        name: arr[j][i],
                        max: arr[j][i + 1],
                        min: arr[j][i + 2],
                    });
                } else {
                    break;
                }
            }
            tempIndicatorData.push(indicatorData);
            i += lengthOffset;
        }
        if (inputValueLength != valueLength) {
            valueLength = inputValueLength;
        }
        let loopData = valueLength;
        let loopCount = 0;
        let tempSeriesData: any = [];
        let seriesData = [];
        for (let i = 0; i < nameList.length; i++) {
            let obj: any = {
                seriesName: "",
                name: "",
                data: [],
                itemStyle: getItemStyle(nameList[i + 3], i + 3),
            };
            let temp = [];
            obj.seriesName = nameList[i - loopCount];
            obj.name = nameList[i + 3];
            for (let j = 0; j < arr.length; j++) {
                temp.push(arr[j][i + 3]);
            }
            obj.data = temp.filter((item: any) => item != "");
            seriesData.push(obj);
            loopCount += 1;
            if (loopCount == loopData) {
                tempSeriesData.push(seriesData);
                seriesData = [];
                // 循环达成指定次数，进入下一组循环
                loopCount = 0;
                i += 3;
            }
        }
        // 暂不支持增、删雷达
        for (let i = 0; i < radar.length; i++) {
            if (tempIndicatorData[i]) {
                radar[i].indicator = tempIndicatorData[i];
            }
        }

        let newSeriesLength = tempSeriesData.length;
        let newLegend = [];
        for (let i = 0; i < newSeriesLength; i++) {
            let name = tempSeriesData[i][0].seriesName;
            seriesList[i].name = name;
            let temp = [];
            for (let item of tempSeriesData[i]) {
                newLegend.push(item.name);
                temp.push({
                    name: item.name,
                    value: item.data,
                    itemStyle: item.itemStyle,
                });
            }
            seriesList[i].data = temp;
        }
        legend[0].data = newLegend;
        return {
            series: seriesList,
            legend: legend,
            radar,
        };
    }
    changeDatasetForBoxplot(arr: Array<Array<string>>) {
        const nowOption = this.option;
        const whirlRet = this.whirl2DArray(arr);
        const dataset = this.deepClone(nowOption.dataset);
        const edEchartMap = [];
        const source = [];

        whirlRet.forEach((rowArr, index) => {
            const valuesArr = this.deepClone(rowArr);
            valuesArr.shift();
            const newValuesArr = [];
            for (let i = 0; i < valuesArr.length; i++) {
                if (`${valuesArr[i]}`.trim() !== "") {
                    const value = Number(valuesArr[i]);
                    if (!isNaN(value)) {
                        newValuesArr.push(value);
                    }
                }
            }

            if (newValuesArr.length > 0) {
                source.push(newValuesArr);
                const obj = nowOption.edEchartMap[index] ?? {
                    name: "",
                    color: "#5470c6",
                    symbol: "circle",
                    symbolSize: 10,
                };
                let newName = rowArr[0].trim();
                if (newName === "") {
                    newName = `expr${index}`;
                }
                edEchartMap.push(Object.assign(obj, { name: newName }));
            }
        });

        dataset[0].source = source;
        return {
            edEchartMap,
            dataset,
        };
    }
    changeDatasetForHeatmap(arr: Array<Array<string>>) {
        const nowOption = this.option;
        const seriesList = this.deepClone(nowOption.series);
        let offset = 0;
        for (let item of seriesList) {
            let source = item.data;
            let count = source[0].length;
            for (let i = 0; i < source.length; i++) {
                source[i] = arr[i].slice(offset, offset + count);
            }
            offset += count;
        }
        return {
            series: seriesList,
        };
    }
    changeDatasetForGraph(arr: Array<Array<string>>) {
        const nowOption = this.option;
        const seriesList = this.deepClone(nowOption.series);
        arr.shift();
        let data = new Map();
        let dataIndex = 0;
        let categories = [];
        let link = [];
        let linkMap = new Map();
        for (let item of arr) {
            if (item.length == 4) {
                if (!categories.includes(item[0])) {
                    categories.push(item[0]);
                }
                let categoriyIndex = categories.findIndex((cItem) => cItem == item[0]);
                if (!data.has(item[1])) {
                    data.set(item[1], {
                        id: "" + dataIndex,
                        category: categoriyIndex,
                        name: item[1],
                        value: item[2],
                        symbolSize: (parseFloat(item[2]) * 2) / 3,
                    });
                    linkMap.set(item[1], dataIndex), dataIndex++;
                }
                link.push([item[1], item[3]]);
            } else if (item.length == 3) {
                let categoriyIndex = categories.findIndex((cItem) => cItem == item[0]);
                if (!data.has(item[1])) {
                    data.set(item[1], {
                        id: "" + dataIndex,
                        category: categoriyIndex,
                        name: item[1],
                        value: item[2],
                        symbolSize: (parseFloat(item[2]) * 2) / 3,
                    });
                    linkMap.set(item[1], dataIndex), dataIndex++;
                }
            }
        }
        let cate = categories.map((item, index) => {
            return {
                name: item,
                itemStyle: {
                    color: this.getSeriesColor(index),
                },
            };
        });
        let links = link
            .filter((item) => {
                return item[0] && item[1];
            })
            .map((item) => {
                return {
                    source: "" + linkMap.get(item[0]),
                    target: "" + linkMap.get(item[1]),
                };
            });
        let obj = {
            categories: cate,
            data: Array.from(data).map((item) => item[1]),
            links,
        };

        seriesList.forEach((element) => {
            return Object.assign(element, obj);
        });

        return {
            series: seriesList,
        };
    }
    changeDatasetForSunburst(arr: Array<Array<string>>) {
        const nowOption = this.option;
        const seriesList = this.deepClone(nowOption.series);
        let map = new Map();
        let result: any = [];
        arr.shift();
        let oldMap = new Map();
        let oldData = this.deepClone(seriesList[0].data);
        const readNodes = (nodes = []) => {
            for (let item of nodes) {
                oldMap.set(item.name, item);
                if (item.children && item.children.length) readNodes(item.children);
            }
            return arr;
        };
        let noChange = true;
        readNodes(oldData);
        for (let i = 0; i < arr.length; i++) {
            let item = arr[i];
            let parentName: any = item[2];
            if (parentName == "null") {
                let obj = {
                    name: item[0],
                    value: parseFloat(item[1]),
                    children: [],
                    itemStyle: oldMap.get(item[0])?.itemStyle || { color: this.getSeriesColor(i) },
                };
                map.set(item[0], obj);
                result.push(obj);
            } else {
                if (map.has(parentName)) {
                    let obj = {
                        name: item[0],
                        value: parseFloat(item[1]),
                        children: [],
                        itemStyle: oldMap.get(item[0])?.itemStyle || map.get(parentName).itemStyle || { color: this.getSeriesColor(i) },
                    };
                    map.set(item[0], obj);
                    map.get(parentName).children.push(obj);
                } else {
                    noChange = true;
                }
            }
        }
        if (noChange) {
            // 可能存在修改后数据无变动，手动释放working状态
            this.working = true;
        }
        seriesList[0].data = this.formatSunburstData(result);
        return {
            series: seriesList,
        };
    }
    changeDatasetForParallel(arr: Array<Array<number | string>>) {
        const nowOption = this.option;
        const legend = this.deepClone(nowOption.legend);
        const oldParallel = nowOption.parallelAxis;
        let seriesList = this.deepClone(nowOption.series);
        let paraList = [];
        let data = [];
        // ---------    series1  --       --
        // ---------    data1    data2    data3
        // parallel1    1        2        3
        // parallel2    1        2        3

        for (let i = 0; i < arr.length; i++) {
            if (i < 2) continue; // 前两列为固定格式，无意义
            let seriesName = "";
            for (let j = 0; j < arr[i].length; j++) {
                if (arr[0][j]) {
                    // arr首行，series名称
                    seriesName = "" + arr[0][j];
                }
                if (j == 0) {
                    // 首列，记录平行图坐标轴名称
                    let obj = {};
                    if (oldParallel[i - 2]) {
                        // 如有旧坐标轴数据，克隆一份
                        Object.assign(obj, oldParallel[i - 2]);
                    }
                    if (arr[i][j + 1] && isNaN(parseFloat(arr[i][j + 1] as string))) {
                        // 如数据为字符串类型，需额外设置type以及data
                        Object.assign(obj, {
                            dim: i - 2,
                            name: arr[i][j],
                            type: "category",
                            data: [],
                        });
                    } else {
                        Object.assign(obj, {
                            dim: i - 2,
                            name: arr[i][j],
                        });
                    }
                    paraList.push(obj);
                    data[0] = [];
                } else {
                    // 按列记录每个series下数据
                    if (!data[j]) {
                        data.push([seriesName, arr[i][j]]);
                    } else {
                        data[j].push(arr[i][j]);
                    }
                }
            }
        }

        // 按series名称分组数据，用map格式记录
        let temp = data.reduce((a, c) => {
            if (c.length == 0) return a;
            let key = c.shift();
            if (a.has(key)) {
                a.get(key).push(c);
            } else {
                a.set(key, [c]);
            }
            return a;
        }, new Map());

        let seriesName = [];
        for (let [key, value] of temp) {
            seriesName.push(key);
        }

        // 对category坐标轴赋值data数据
        for (let i = 0; i < paraList.length; i++) {
            if (paraList[i].type == "category") {
                let obj = temp.get(seriesName[0]);
                paraList[i].data = obj.map((item) => item[i]);
            }
        }

        // 根据修改前后数据行数判断是否新增或删除
        if (seriesName.length < seriesList.length) {
            let newSeries = [];
            let i = 0;
            let lineWidth = seriesList[0] ? seriesList[0].lineStyle.width : 1;
            for (let item of seriesName) {
                newSeries.push({
                    type: "parallel",
                    name: item,
                    data: temp.get(item),
                    lineStyle: {
                        width: lineWidth,
                        color: seriesList[i]?.lineStyle?.color || this.getSeriesColor(i),
                    },
                });
                i++;
            }
            seriesList = newSeries;
        } else if (seriesName.length == seriesList.length) {
            seriesList.forEach((element, index) => {
                element.name = seriesName[index];
                element.data = temp.get(seriesName[index]);
            });
        } else {
            let newSeries = [];
            seriesList.forEach((element, index) => {
                element.name = seriesName[index];
                element.data = temp.get(seriesName[index]);
                newSeries.push(element);
            });
            let lineWidth = seriesList[0] ? seriesList[0].lineStyle.width : 1;
            for (let i = seriesList.length; i < seriesName.length; i++) {
                let item = seriesName[i];
                newSeries.push({
                    type: "parallel",
                    name: item,
                    data: temp.get(item),
                    lineStyle: {
                        width: lineWidth,
                        color: seriesList[i]?.lineStyle?.color || this.getSeriesColor(i),
                    },
                });
            }
            seriesList = newSeries;
        }

        legend[0].data = seriesName;
        return {
            legend: legend,
            parallelAxis: paraList,
            series: seriesList,
        };
    }
    changeDatasetForSankey(arr: Array<Array<number | string>>) {
        // TOFIX: 生成桑基图的数据时，还需要设置 data.itemStyle.color
        const nowOption = this.option;
        const seriesList = this.deepClone(nowOption.series);
        const links = [];
        let colorMap = new Map();
        for (let item of seriesList[0].data) {
            colorMap.set(item.name, item.itemStyle);
        }
        const resetData = () => {
            // 根据links关系重新生成data内容
            let temp = new Map();
            let data = [];
            let i = 0;
            for (let item of links) {
                let source = item.source;
                let target = item.target;
                if (!temp.get(source)) {
                    data.push({
                        name: source,
                        itemStyle: colorMap.get(source) || { color: this.getSeriesColor(i) },
                    });
                    temp.set(source, 1);
                }

                if (!temp.get(target)) {
                    data.push({
                        name: target,
                        itemStyle: colorMap.get(target) || { color: this.getSeriesColor(i) },
                    });
                    temp.set(target, 1);
                }
                i++;
            }
            delete seriesList[0].data;
            seriesList[0].data = data;
        };

        arr.forEach((item, i) => {
            if (item[0] && item[1] && item[2]) {
                const link: any = {
                    source: item[0],
                    target: item[1],
                    value: item[2],
                    lineStyle: { opacity: 0.2 },
                };
                const oldLink = seriesList[0].links.find((oLink) => oLink.source === link.source && oLink.target === link.target);
                if (oldLink?.lineStyle) {
                    link.lineStyle = oldLink.lineStyle;
                }
                links.push(link);
            }
        });
        seriesList[0].links = links;

        resetData();
        return {
            series: seriesList,
        };
    }
    changeDatasetForFunnel(arr: Array<Array<number | string>>) {
        const nowOption = this.option;
        const seriesList = this.deepClone(nowOption.series);
        const legend = this.deepClone(nowOption.legend);

        if (seriesList.length > 1) {
            let count = 0;
            seriesList.forEach((series) => {
                series.data.forEach((item) => {
                    item.name = arr[count][0];
                    item.value = arr[count][1];
                    count++;
                });
            });
        } else {
            let data = seriesList[0].data;
            let newList = [];
            for (let j = 0; j < arr.length; j++) {
                let nName = arr[j][0] as string;
                let oName = data[j]?.name || "";
                if (nName != oName) {
                    if (oName == "") {
                        this.datasetLegend(legend, "add", j, nName);
                    } else {
                        this.datasetLegend(legend, "change", j, nName, oName);
                    }
                }
                newList.push({
                    name: nName,
                    value: arr[j][1],
                    itemStyle: data[j]?.itemStyle || { color: this.getSeriesColor(j) },
                });
            }
            seriesList[0].data = newList;
        }

        return {
            series: this.formatFunnelData(seriesList),
            legend,
        };
    }
    changeDatasetForGauge(arr: Array<Array<number | string>>) {
        console.log(arr);
        const nowOption = this.option;
        const seriesList = this.deepClone(nowOption.series);
        let count = 0;
        for (let i = 0; i < seriesList.length; i++) {
            let data = seriesList[i].data;
            if (data) {
                for (let j = 0; j < data.length; j++) {
                    data[j].name = arr[j + count][0] as string;
                    data[j].value = arr[j + count][1];
                }
                count += seriesList[i].data.length;
            }
        }
        return {
            series: seriesList,
        };
    }
    changeDatasetForWaterfall(arr: Array<Array<number | string>>) {
        const nowOption = this.option;
        const seriesList = this.deepClone(nowOption.series);

        const valueArr = this.deepClone(arr).map((item) => item[0]);
        valueArr.shift();
        const pArr: any = [0];
        const iArr = [];
        const eArr = [];

        valueArr.forEach((item) => {
            let value = Number(item);
            value = isNaN(value) ? 0 : value;

            pArr.push(pArr[pArr.length - 1] + value);

            if (value >= 0) {
                iArr.push(value);
                eArr.push("-");
            } else {
                iArr.push("-");
                eArr.push(-value);
            }
        });

        // pArr初始化时添加了一个值，这里删除最后一个值，避免pArr多一个值
        pArr.pop();

        // 值减少时，Placeholder值还需要减去减少的值
        valueArr.forEach((item, index) => {
            let value = Number(item);
            value = isNaN(value) ? 0 : value;
            if (index > 0 && value < 0) {
                pArr[index] += value;
            }
        });

        // 不支持负值显示。Placeholder是负值时改成0
        for (let i = 0; i < pArr.length; i++) {
            if (pArr[i] < 0) {
                pArr[i] = 0;
            }
        }

        // 加上原有的颜色设置
        seriesList[1].data.forEach((item, index) => {
            if (item.itemStyle) {
                iArr[index] = {
                    value: iArr[index],
                    itemStyle: item.itemStyle,
                };
            }
        });
        seriesList[2].data.forEach((item, index) => {
            if (item.itemStyle) {
                eArr[index] = {
                    value: eArr[index],
                    itemStyle: item.itemStyle,
                };
            }
        });

        seriesList[0].data = pArr;
        seriesList[1].data = iArr;
        seriesList[2].data = eArr;

        return {
            series: seriesList,
        };
    }
    formatOptionStackBarNor(option) {
        const dataArr = option.series.map((item) => item.edOriginData);
        const totalArr = [];
        for (let i = 0; i < dataArr[0].length; i++) {
            let sum = 0;
            for (let j = 0; j < dataArr.length; j++) {
                sum += Number(dataArr[j][i]);
            }
            totalArr.push(sum);
        }
        option.series.forEach((serie) => {
            const formatData = serie.edOriginData.map((item, index) => (totalArr[index] >= 0 ? Number(item) / totalArr[index] : 0));
            serie.data = formatData;
        });
    }
    loopSetId(item: any, parentId = "", index = 0) {
        if (parentId) {
            item.id = `${parentId}-${index + 1}`;
        } else {
            item.id = `${index + 1}`;
        }
        if (item?.children?.length > 0) {
            item.children.forEach((child, childIndex) => this.loopSetId(child, item.id, childIndex));
        }
    }
    formatSunburstData(data) {
        data.forEach((item, index) => this.loopSetId(item, "", index));
        return data;
    }
    formatFunnelData(seriesList) {
        seriesList.forEach((serie) => {
            serie.data.sort((a, b) => Number(b.value) - Number(a.value));
            serie.data.forEach((item, index) => {
                if (!item.tooltip) {
                    item.tooltip = {};
                }

                let pecentNum = 0;
                if (index === 0) {
                    pecentNum = 100;
                } else {
                    let lastValue = serie.data?.[index - 1]?.value;
                    lastValue = Number(lastValue);
                    const currentValue = Number(item.value);
                    if (!isNaN(lastValue) && !isNaN(currentValue) && lastValue !== 0) {
                        pecentNum = Math.round((currentValue / lastValue) * 10000) / 100;
                    }
                }

                item.tooltip.formatter = `${item.name}: ${item.value}<br>${pecentNum}%`;
            });
        });
        return seriesList;
    }
}
export const chartData = new ChartData();
